import { AntragSupportingData } from '../interfaces';
import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { ResourceProvider } from '../providers/resource/resource';
import { TokenState } from '../models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AntragSupportingDataService {
  private readonly resourceProvider = inject(ResourceProvider);
  private readonly _statesThatIndicateDifferentToken = new Set([TokenState.Outdated, TokenState.Na]);
  private cache$: Observable<AntragSupportingData> | undefined;

  public hasEncryptionIssue(tokenState: TokenState): Observable<boolean> {
    return this.supportingData.pipe(map((x) => x.statesForAntragEncryptionHasIssues.has(tokenState)));
  }

  private get supportingData(): Observable<AntragSupportingData> {
    if (!this.cache$) {
      this.cache$ = this.requestSupportingData().pipe(shareReplay(1));
    }

    return this.cache$;
  }

  private requestSupportingData(): Observable<AntragSupportingData> {
    return this.resourceProvider.getAntragStates().pipe(
      map(
        (o) =>
          ({
            ...o,
            statesForAntragEncryptionHasIssues: this._statesThatIndicateDifferentToken,
          }) as AntragSupportingData,
      ),
    );
  }
}
